import type { Client } from 'urql';
import type { OperationResult } from 'urql';

import type { CustomerQuery } from '@order/graphql';

import { customerQuery } from './customer.queries';

// ─────────────────────────────────────────────────────────────────────────────

export async function fetchCustomer(client: Client): Promise<CustomerData> {
  const responseFromCache = await customerQuery(client, 'cache-and-network');

  return responseFromCache.data?.currentCustomer ?? null;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomerData = NonNullable<
  OperationResult<CustomerQuery, Record<string, unknown>>['data']
>['currentCustomer'];
